import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@/api/constants";
import type { PaginationParams } from "@/types/api";

import { apiRestaurantDiners } from "./apiRestaurantDiners";
import { DinerPath } from "./types";

type RestaurantDinersParams = Partial<PaginationParams> & {
  dinerId?: string;
};

export const useGetRestaurantGroupDinersQuery = (
  id: string,
  params?: RestaurantDinersParams,
  enabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.restaurantGroupDiners, id, params],
    queryFn: () => apiRestaurantDiners.getById(DinerPath.GROUP, id, params),
    enabled: enabled && !!id,
  });
};

export const useGetRestaurantBrandDinersQuery = (
  id: string,
  params?: RestaurantDinersParams,
  enabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.restaurantBrandDiners, id, params],
    queryFn: () => apiRestaurantDiners.getById(DinerPath.BRAND, id, params),
    enabled: enabled && !!id,
  });
};

export const useGetRestaurantBranchDinersQuery = (
  id: string,
  params?: RestaurantDinersParams,
  enabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.restaurantBranchDiners, id, params],
    queryFn: () => apiRestaurantDiners.getById(DinerPath.BRANCH, id, params),
    enabled: enabled && !!id,
  });
};

export const useGetRestaurantAllBranchDinersQuery = (
  params?: RestaurantDinersParams,
  enabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.restaurantAllBranchDiners, params],
    queryFn: () => apiRestaurantDiners.getAll(DinerPath.BRANCH, params),
    enabled,
  });
};

export const useGetRestaurantAllBrandsDinersQuery = (
  params?: RestaurantDinersParams,
  enabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.restaurantAllBrandDiners, params],
    queryFn: () => apiRestaurantDiners.getAll(DinerPath.BRAND, params),
    enabled,
  });
};
